import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import EmployeeInfoForm from "./EmployeeInfoForm";
import EmegencyContactForm from "./EmegencyContactForm";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import {
	getEmployeeDetails,
} from "../../../../redux/employee/employeeState";
import { formatAddress, isSeparatedEmployee, getLabel, contactDetailName } from "utils/index";
import InfoCard from "components/card/InfoCard";
import DetailCard from "components/card/DetailCard";
import {
	LuBuilding2,
	LuCalendar,
	LuLayers,
	LuUser,
	LuPhone,
	LuCreditCard,
	LuMail,
	LuMapPin,
	LuUserCheck2,
	LuUserCircle2,
	LuUserCheck,
} from "react-icons/lu"




const EmployeeDetails = ({
	getRecord,
	recordData,
	recordId,
}) => {
	const [employee, setEmployee] = useState(null);

	useEffect(() => {
			getRecord(recordId);
		}, [recordId, getRecord]);

	useEffect(() => {
		if (recordData) {
			setEmployee(recordData);
		}
	}, [recordData]);

  	return (
		<>
			<div className="grid grid-cols-5 gap-x-4">
				<div className="col-span-3">
					<div className="content-wrapper p-5 mb-4 border rounded-xl shadow-md">
						<SectionHeader title="Personal Info">
							<PopupButton id="edit_employee" title="Edit Employee" label="Edit">
								<EmployeeInfoForm recordId={recordId} mode="edit" />
							</PopupButton>
						</SectionHeader>
						<Form layout="vertical">
							<div className="grid grid-cols-2 gap-4 w-full">
								<InfoCard 
									label="Contact"
									icon={<LuPhone />}
									value={recordData?.user_detail?.contact_details?.cde_mobile_number}
									span="col-span-1"
								/>
								<InfoCard 
									label="Email"
									icon={<LuMail />}
									value={recordData?.emp_email}
									span="col-span-1"
								/>
								<InfoCard 
									label="Address"
									icon={<LuMapPin />}
									value={formatAddress(recordData?.user_detail?.address)}
									span="col-span-2"
								/>
								<div className="col-span-2">
									<DetailCard
										title="Credentials"
										icon={LuUserCheck2}
										details={[
											{ 
												label: "TIN #", 
												value: recordData?.emp_tin
											},
											{ 
												label: "SSS #", 
												value: recordData?.emp_sss_number 
											},
											{ 
												label: "Pagibig #", 
												value: recordData?.emp_pagibig_number 
											},
											{ 
												label: "Pagibig #(2)", 
												value: recordData?.emp_pagibig_number_2 
											},
											{ 
												label: "Bank Account Number", 
												value: recordData?.emp_bank_account 
											},
										]}
									/> 
								</div>
							</div>
						</Form>
					</div>
					{/* Emergency Info */}
					<div className="content-wrapper p-5 border rounded-xl shadow-md">
						<SectionHeader title="Emergency Contact Info">
							<PopupButton id="edit_emergency_contact" title="Edit Emergency Contact" label="Edit">
								<EmegencyContactForm recordId={recordId} mode="edit" />
							</PopupButton>
						</SectionHeader>

						<Form layout="vertical">
							<div className="grid grid-cols-2 gap-4">
								<InfoCard 
									label="Name"
									icon={<LuUserCircle2 />}
									value={contactDetailName(recordData?.user_detail?.emergency_contact_person)}
									span="col-span-1"
								/>
								<InfoCard 
									label="Number"
									icon={<LuPhone />}
									value={contactDetailName(recordData?.user_detail?.emergency_contact_person)}
									span="col-span-1"
								/>
								<InfoCard 
									label="Email"
									icon={<LuMail />}
									value={recordData?.user_detail?.emergency_contact_person?.cde_email} 
									span="col-span-1"
								/>
								<InfoCard 
									label="Relation"
									icon={<LuUserCheck/>}
									value={recordData?.user_detail?.emergency_contact_person?.cde_relation || '-'}
									span="col-span-1"
								/>
							</div>
						</Form>
					</div>
				</div>
				<div className="col-span-2">
					<div className="content-wrapper p-5 border rounded-xl shadow-md h-full">
						<SectionHeader title="Employee Details">
							<PopupButton id="edit_employee" title="Edit Employee" label="Edit">
								<EmployeeInfoForm recordId={recordId} mode="edit" />
							</PopupButton>
						</SectionHeader>

						<Form layout="vertical">
							<div className="grid grid-cols-2 gap-4 w-full">
								<InfoCard 
									label="Employee ID"
									icon={<LuCreditCard />}
									value={recordData?.emp_code}
									span="col-span-1"
								/>
								<InfoCard 
									label="Hire Date"
									icon={<LuCalendar />}
									value={recordData?.emp_hire_date}
									span="col-span-1"
								/>
								<InfoCard 
									label="Employee Type"
									icon={<LuUser />}
									value={getLabel(recordData?.employmentTypeList, recordData?.emp_employment_type_id)}
									span="col-span-1"
								/>
								<InfoCard 
									label="Job Level"
									icon={<LuLayers />}
									value={getLabel(recordData?.jobLevelList, recordData?.emp_job_level_id)}
									span="col-span-1"
								/>
								<InfoCard 
									label="Client Name"
									icon={<LuBuilding2 />}
									value={getLabel(recordData?.clientList, recordData?.emp_client_id)}
									span="col-span-2"
								/>
								{isSeparatedEmployee(recordData) &&
									<InfoCard 
										label="Separation Date"
										icon={<LuCalendar />}
										value={recordData?.emp_separation_date}
										span="col-span-2"
									/>
								}	
							</div>
						</Form>
					</div>
				</div>
			</div>	
		</>
  	);
};

const mapStateToProps = (state) => ({
  recordData: state.employee.employeeDetails?.data,
  requesting: state.employee.employeeDetails?.requesting,
  success: state.employee.employeeDetails?.success,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getEmployeeDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetails);


